import styled from "styled-components";

export const ReportsWrap = styled.section`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 40px;
  background: transparent;
  @media (max-width: 767px) {
    padding: 16px 4px;
  }
`;

export const ReportsHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  .blockTitle {
    width: 100%;
    border: 1px solid #8c8c8c;
    border-left: 6px solid #f15a24;
    background: transparent;
    color: #022142;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 64px;
    // margin-bottom: 24px;
    text-align: left;
    padding: 4px 12px;
  }
  .uploadBtn {
    min-width: max-content;
    margin: auto;
    height: 74px;
    background: #022142;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
      background: #f15a24;
    }
  }
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
    .blockTitle {
      font-size: 24px;
      line-height: 32px;
    }
    .uploadBtn {
      font-size: 14px;
      padding: 8px 16px;
    }
  }
`;

export const SearchAndFilterWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReportsBody = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  align-items: flex-start;
  @media (max-width: 1100px) {
    flex-direction: column;
    gap: 16px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const FilterSidebar = styled.aside`
  width: 260px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .filterTitle {
    font-size: 18px;
    font-weight: 600;
    color: #022142;
  }
  .searchBox {
    margin-bottom: 16px;
  }
  .filterGroup {
    padding: 12px;
    background: #F4F4F4;
    margin-bottom: 16px;
    .groupLabel {
      border-bottom: 1px solid #e0e0e0;
      font-size: 14px;
      font-weight: 500;
      color: #555;
      margin-bottom: 6px;
      display: block;
    }
    .filterList {
      display: flex;
      flex-direction: column;
      gap: 6px;
      label {
        font-size: 14px;
        color: #222;
        display: flex;
        align-items: center;
        gap: 8px;
        input[type="checkbox"] {
          accent-color: #022142;
        }
      }
    }
  }
  @media (max-width: 1100px) {
    width: 100%;
    flex-direction: row;
    gap: 16px;
    padding: 16px 8px;
  }
  @media (max-width: 767px) {
    width: 100%;
    padding: 8px 4px;
  }
`;

export const ReportsTableWrap = styled.div`
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 24px;
  min-width: 0;
  @media (max-width: 1100px) {
    padding: 12px;
  }
  @media (max-width: 767px) {
    padding: 4px;
  }
`;

export const ReportsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    background: #f3f5f7;
    th {
      font-size: 16px;
      font-weight: 600;
      color: #022142;
      padding: 12px 8px;
      text-align: left;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }
    }
    td {
      font-size: 15px;
      color: #222;
      padding: 10px 8px;
      vertical-align: middle;
    }
  }
`;

export const PaginationWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const ScoutingReportContainer = styled.div`
  overflow: hidden;
  width: 100vw;
  margin-bottom: 50px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 40px;
`;

export const ScoutingReportMain = styled.div`
  margin-top: 20px;
  display: flex;
  background: transparent;
  overflow: hidden;
  min-width: 80%;
`;

export const ScoutingReportImageSection = styled.div`
  flex: 1 1 350px;
  min-width: 320px;
  max-width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HelmetImage = styled.img`
  width: 100%;
  max-width: 350px;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
`;

export const ScoutingReportDetailsSection = styled.div`
  background: transparent;
  flex: 1 1 600px;
  padding: 32px 32px 32px 24px;
  display: flex;
  align-items: flex-start;
`;

export const PlayerCard = styled.div`
  width: 340px;
  margin-left: 20px;
`;

export const PlayerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const MLBadge = styled.span`
  background: #e6f7e6;
  color: #1a7f37;
  font-size: 13px;
  font-weight: 700;
  border-radius: 4px;
  padding: 4px 10px;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
`;

export const PlayerInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PlayerName = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  color: #022142;
  margin-bottom: 6px;
`;

export const PlayerMeta = styled.div`
  font-size: 1rem;
  color: #444;
  margin-bottom: 10px;
  span {
    margin-right: 18px;
  }
`;

export const TeamLogo = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin: 10px 0 16px 0;
`;

export const PlayerPhysical = styled.div`
  font-size: 1rem;
  color: #222;
  margin-bottom: 10px;
  div {
    margin-bottom: 2px;
  }
`;

export const Verified = styled.span`
  color: #1a7f37;
  font-size: 0.95em;
  margin-left: 4px;
`;

export const PlayerAwards = styled.div`
  margin-top: 8px;
  width: 100%;
`;

export const AwardsLabel = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #022142;
  margin-right: 8px;
`;

export const AwardsIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  span {
    font-size: 1.2rem;
  }
`;
